import api from "$utils/api"

import manifest from "./manifest"

export default api({
  manifest,
})
